import { render, staticRenderFns } from "./AvailableVotesBlock.vue?vue&type=template&id=af6f7e8a&scoped=true&"
import script from "./AvailableVotesBlock.vue?vue&type=script&lang=js&"
export * from "./AvailableVotesBlock.vue?vue&type=script&lang=js&"
import style0 from "./AvailableVotesBlock.vue?vue&type=style&index=0&id=af6f7e8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f7e8a",
  null
  
)

export default component.exports